import { Dialog, DialogContent } from '@/components/ui/dialog';
import { CancellationForm } from '@/lib/layout/forms/cancel';
import type { Policy } from '@/lib/heyapi';
import type { Message } from '@/lib/layout/Header/components/StandardMessage';

export const CancelPolicyDialog = ({
  isOpen,
  onOpenChange,
  policy,
  setMessage,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  policy: Policy | undefined;
  setMessage: (message: Message | undefined) => void;
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <CancellationForm
          policy={policy}
          setMessage={setMessage}
          onOpenChange={onOpenChange}
        />
      </DialogContent>
    </Dialog>
  );
};
